import React, { useEffect, useState } from 'react';
import { UserInput } from 'src/components/profileComponents/Users/components/UserInput';
import InputAdornment from '@mui/material/InputAdornment';
import { appIcon } from 'src/assets';
import { translations } from 'src/constants/translations';
import { useGlobalGrid } from 'src/hooks/app/use-global-grid';
import { useDebounce } from 'src/hooks';
import { useStyles } from './styles';

interface Props {
  placeholder?: string;
  gridWidth?: number;
  onDebouncedSearch?: (value: string) => void;
  onValueChange?: (value: string) => void;
}
export const AppInputSearch: React.FC<Props> = ({
  placeholder = 'search', gridWidth = 2, onDebouncedSearch, onValueChange,
}) => {
  const { getGridsWidth } = useGlobalGrid();
  const styles = useStyles({
    getGridsWidth,
    gridWidth,
  });
  const [search, setSearch] = useState<string>('');
  const debouncedSearch = useDebounce(search, 500);
  useEffect(() => {
    if (onDebouncedSearch) {
      onDebouncedSearch(debouncedSearch);
    }
  }, [debouncedSearch]);
  useEffect(() => {
    if (onValueChange) {
      onValueChange(search);
    }
  }, [search]);
  return (
    <div className={styles.search}>
      <UserInput
        startAdornment={(
          <InputAdornment position="start">
            <img src={appIcon.iconSearch.default} alt="icon search" />
          </InputAdornment>
        )}
        placeholder={placeholder}
        name="search"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />
    </div>
  );
};
